import { type FC, type PropsWithChildren } from 'react'

import { Stack, type StackProps } from '@mui/material'
import { useLayout } from '@core/contexts/layout'

interface Props extends StackProps {
  component?: string
}

export const MobileWrapper: FC<PropsWithChildren<Props>> = ({
  children,
  alignItems = 'center',
  justifyContent = 'center',
  direction = 'row',
  maxWidth,
  mb,
  gap,
  spacing,
  ...props
}) => {
  const { isMobile } = useLayout()

  return (
    <Stack {...props} direction={direction} alignItems={alignItems} justifyContent={justifyContent}>
      <Stack
        flex={1}
        gap={gap}
        position={props.position}
        spacing={spacing}
        maxWidth={maxWidth !== undefined ? maxWidth : isMobile ? '90%' : '144rem'}
        mb={mb !== undefined ? mb : isMobile ? '0.8rem' : '2.4rem'}
      >
        {children}
      </Stack>
    </Stack>
  )
}
